import { render } from "./CheckoutFamiliar.vue?vue&type=template&id=2153b598&scoped=true&lang=true"
import script from "./CheckoutFamiliar.vue?vue&type=script&lang=js"
export * from "./CheckoutFamiliar.vue?vue&type=script&lang=js"

import "./CheckoutFamiliar.vue?vue&type=style&index=0&id=2153b598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2153b598"]])

export default __exports__